import React from "react"
import "./Header.css"

class Header extends React.Component{
    render(){
        return(
            <div className="header">
                <ul className="header_combine">
                    <li className="header_logo">
                        <img src="./images/header_logo.jpg" alt="Header logo"className="header_logo_img"  />
                    </li>
                    <li className="email_phone_combine">
                        <ul className="email">
                        <li>
                        <svg  viewBox="-0.5 -0.5 600 300" id="email_logo" >
                            <g><g>
		                        <path d="M392.9,208.08c-1.19,0-2.38-0.43-3.31-1.31l-55.66-52.22c-1.94-1.82-2.04-4.89-0.21-6.83c1.83-1.96,4.88-2.05,6.84-0.21
			                             l55.66,52.22c1.94,1.82,2.04,4.88,0.21,6.83C395.47,207.57,394.19,208.08,392.9,208.08z"/>
		                        <path d="M207.09,208.08c-1.29,0-2.57-0.51-3.53-1.53c-1.83-1.95-1.73-5.01,0.21-6.83l55.68-52.22c1.95-1.82,5.02-1.74,6.84,0.21
			                             c1.83,1.94,1.73,5.01-0.21,6.83l-55.68,52.22C209.47,207.65,208.28,208.08,207.09,208.08z"/>
	                            </g>
	                            <path d="M425.82,256.63H174.18c-13.33,0-24.18-10.84-24.18-24.18V67.54c0-13.34,10.85-24.18,24.18-24.18h251.63
	                         	       c13.33,0,24.18,10.84,24.18,24.18v164.91C450,245.79,439.15,256.63,425.82,256.63z M174.18,53.03c-8,0-14.51,6.51-14.51,14.51
	                                 	v164.91c0,8,6.51,14.51,14.51,14.51h251.63c8,0,14.51-6.51,14.51-14.51V67.54c0-8-6.51-14.51-14.51-14.51H174.18z"/>
	                            <path d="M300,174.3c-6.43,0-12.87-2.14-17.76-6.4L158.03,59.54c-2.01-1.75-2.23-4.81-0.47-6.83c1.77-2.01,4.82-2.2,6.83-0.46
	                        	         l124.21,108.35c6.18,5.39,16.63,5.39,22.8,0L435.45,52.42c2-1.75,5.05-1.56,6.83,0.46c1.75,2.02,1.55,5.07-0.46,6.83L317.76,167.89
	                        	        C312.86,172.16,306.43,174.3,300,174.3z"/>
                            </g>
                    </svg>
                    </li>

                    <li>info@pellmellsuply.com</li></ul>

                     <ul className="phone"><li>  
                    <svg  viewBox="-0.5 -0.5 600 300" id="phone_logo" >
                      <g>
	                    <path d="M391.11,300c-12.48,0-27.56-3.13-44.14-9.38c-36.35-13.7-75.89-40.79-111.35-76.24c-35.47-35.47-62.55-75.02-76.26-111.37
		                      c-12.46-33.05-12.49-60.17-0.07-72.58c1.79-1.79,3.6-3.7,5.48-5.68c11.33-11.92,24.14-25.33,41.11-24.72
		                      c11.7,0.48,23.03,7.75,34.63,22.19c34.29,42.64,18.83,57.84,0.94,75.46l-3.16,3.13c-2.93,2.93-8.46,16.48,42.99,67.92
		                      c16.79,16.79,31.11,29.08,42.55,36.52c7.2,4.68,20.09,11.77,25.38,6.48l3.18-3.21c17.6-17.85,32.79-33.26,75.41,1
		                      c14.44,11.6,21.69,22.93,22.18,34.64c0.7,16.96-12.81,29.8-24.74,41.12c-1.97,1.88-3.88,3.69-5.67,5.47
		                      C413.39,296.9,403.53,300,391.11,300z M204.67,10.09c-12.06,0-22.95,11.46-32.58,21.6c-1.94,2.04-3.81,4.02-5.66,5.86
		                      c-9.25,9.24-8.31,33.53,2.38,61.9c13.22,35.03,39.48,73.32,73.96,107.8c34.47,34.46,72.73,60.72,107.78,73.93
		                      c28.36,10.72,52.65,11.62,61.89,2.39c1.85-1.85,3.82-3.72,5.86-5.65c10.36-9.85,22.12-21.01,21.6-33.39
		                      c-0.35-8.51-6.55-17.66-18.42-27.19c-35.51-28.56-45.44-18.48-61.91-1.78l-3.23,3.26c-7.87,7.88-20.66,6.13-38.01-5.15
		                      c-12.04-7.83-26.91-20.56-44.19-37.85c-42.69-42.68-56.35-68.81-42.99-82.2l3.22-3.18c16.74-16.47,26.84-26.41-1.73-61.94
		                      c-9.56-11.86-18.7-18.05-27.2-18.41C205.19,10.09,204.93,10.09,204.67,10.09z"/>
                        </g>
                        </svg></li>
                        <li> 619-434-4035</li></ul>

                    </li>
                </ul>
            </div>
        )
    }
}
export default Header;